module.exports = function(moduleName) {
  try {
    return module.parent.require(moduleName);
  } catch (e) {
    // This could mean that we are in a browser context.
    // Add another try catch like it used to be, for backwards compability
    // and browserify reasons.
    try {
      return require(moduleName);
    }
    catch (e) {}
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/fhir.js/~/request/lib/optional.js
// module id = 486
// module chunks = 0